import { useState, useEffect } from 'react';
import 'regenerator-runtime/runtime';
import { httpClient, HttpMethods, isHttpClientError, type HttpMethod } from '../utils/httpClient';

export const FetchRequestTypes = HttpMethods;

export const useFetch = (urls: string | string[] | null, requestType: HttpMethod, requestData?: any[] | null) => {
  const [data, setData] = useState<any | any[]>(null);
  const [error, setError] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(true);

  const runSingleRequest = async (url: string): Promise<any> => {
    if (requestType === FetchRequestTypes.POST) {
      return httpClient.post<any>(url);
    }

    if (requestType === FetchRequestTypes.PUT && requestData?.length === 1) {
      return httpClient.put<any>(url, requestData[0]);
    }

    if (requestType === FetchRequestTypes.DELETE) {
      return httpClient.delete<any>(url);
    }

    return httpClient.get<any>(url);
  };

  const runMultipleRequests = async (requestUrls: string[]): Promise<any[]> => {
    if (requestType === FetchRequestTypes.PUT && requestData && requestData.length > 0) {
      const requests = requestUrls.map((url, index) => httpClient.put<any>(url, requestData[index]));
      return httpClient.all<any>(requests);
    }

    if (requestType === FetchRequestTypes.POST) {
      const requests = requestUrls.map((url) => httpClient.post<any>(url));
      return httpClient.all<any>(requests);
    }

    if (requestType === FetchRequestTypes.DELETE) {
      const requests = requestUrls.map((url) => httpClient.delete<any>(url));
      return httpClient.all<any>(requests);
    }

    const requests = requestUrls.map((url) => httpClient.get<any>(url));
    return httpClient.all<any>(requests);
  };

  useEffect(() => {
    const run = async (): Promise<void> => {
      if (!urls) {
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        setError(null);

        if (typeof urls === 'string') {
          const response = await runSingleRequest(urls);
          setData(response);
        } else {
          const responses = await runMultipleRequests(urls);
          setData(responses);
        }
      } catch (fetchError) {
        if (isHttpClientError(fetchError)) {
          setError('HTTP Error with Message: ' + fetchError.message);
        } else {
          setError(fetchError);
        }
      } finally {
        setLoading(false);
      }
    };

    run();
  }, [urls, requestType, requestData]);

  return { data, error, loading };
};
